import React, { useState, useEffect } from 'react'
import { Stack, styled } from '@mui/material'
import { useSidebarContext } from '../../../contexts/Old_SidebarContext'

import { DRAWER_WIDTH } from '../constants'
import Sidebar from '../LeftSidebar/Actions/Sidebar'
import NewMessage from './NewMessage'
import SendMessage from './SendMessage'
import { useSnackbar } from '../../../components/SnackbarProvider'
import { useParams } from 'react-router-dom'
// import { HistoryContext } from '../../../contexts/HistoryContext'
import Stepper from './Messages/Actions/Stepper'
import baseUrl from '../../../config/baseUrl'

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: any
}>(({ theme, open }) => ({
  display: 'flex',
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),

  padding: theme.spacing(2, 4, 2, 2),
  marginLeft: `-${DRAWER_WIDTH}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: theme.spacing(2),
  }),
}))

const MainContent = () => {
  const {
    isLoading,
    sidebarOpen,
    allHistory,
    aiStorage,
    setAiStorage,
    setInputMessage,
    setAnswer,
    setThreadId,
    // setIsThreadIdDelete,
    // isThredIdDelete,
    threadId,
  } = useSidebarContext()

  const token = sessionStorage.getItem('token')
  const param = useParams()
  const { id } = param
  const showSnackbar = useSnackbar()

  useEffect(() => {
    document.title = 'Main content - Lawttorney'
  }, [])

  useEffect(() => {
    if (id !== '') {
      // setIsLoading(true)
      setThreadId((prevId: any) => (prevId = id))
    }
  }, [id])

  useEffect(() => {
    threadId !== '' && getUserHistory()
  }, [threadId])

  // For Pagination :

  const [mergedData, setMergedData] = useState<any>([])

  useEffect(() => {
    if (allHistory.length > 0) {
      const newArray = allHistory.map((obj: any) => {
        // console.log('obj inside allHistory', obj)
        if (obj.subSerach) {
          return {
            ...obj,
            subSerach: [obj, ...obj.subSerach], // Move the object into subSerach
          }
        } else {
          return obj
        }
      })

      setMergedData(newArray)
    }
  }, [allHistory])

  // Updated code for pagination 3

  const [subSearchActiveSteps, setSubSearchActiveSteps] = useState<any>(allHistory.map(() => 0))

  useEffect(() => {
    setSubSearchActiveSteps(allHistory.map(() => 0))
  }, [allHistory])

  const getUserHistory = async () => {
    try {
      const userHistoryRespo = await fetch(`${baseUrl}/api/users/gethistory/${id as string}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          authorization: token as string,
        },
      })

      const userHistoryData = await userHistoryRespo.json()
      // console.log('userHistoryData', userHistoryData)
      userHistoryData && setAiStorage(userHistoryData)
      // setIsLoading(false)
    } catch (error: any) {
      // setIsLoading(false)
      // console.log('This Error occur in fetching history ', error.message)
      showSnackbar(
        'This Error occur in fetching history, please try again later or check your network connection...',
        'error',
      )
    }
  }

  const handleSubSearchStepChange = (index: number, step: number) => {
    setSubSearchActiveSteps((prevActiveSteps: any) => {
      const newActiveSteps = [...prevActiveSteps]
      newActiveSteps[index] = step
      return newActiveSteps
    })
  }

  // Handle search count

  // const userId = sessionStorage.getItem('userId')

  // const isPaid = sessionStorage.getItem('isPaid')

  return (
    <div
      style={{
        left: '335px',
        marginTop: '5.5rem',
        height: 'calc(100vh - 5.5rem)',
        overflow: 'hidden',
      }}
    >
      {isLoading && (
        <div
          style={{
            // height: '100dvh',
            // width: '100dvw',
            zIndex: 1350,
            position: 'absolute',
            // backgroundColor: 'rgba(202, 92, 92, 0.5)',
          }}
        >
          {/* <h3 style={{ color: 'green', position: 'fixed', top: '45%', left: '45%' }}>
            Fetching data...
          </h3> */}

          {/* <CircularProgress
            disableShrink
            color='primary'
            thickness={4}
            style={{ position: 'fixed', top: '50%', left: '50%' }}
          /> */}
        </div>
      )}
      {/* {openVerifier && <Verifier anchorSide='left' openVerifier={true} />} */}
      <Main open={sidebarOpen} sx={{ height: '100%', overflow: 'hidden' }}>
        {!sidebarOpen && <Sidebar />}
        <Stack
          flexGrow={1}
          alignItems='center'
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Stack
            spacing={2}
            width={1}
            maxWidth={1000}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <Stack
              flex={1}
              spacing={2}
              sx={{
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingBottom: 2,
                minHeight: 0,
              }}
            >
              {/* <ActiveFilters /> */}

              {mergedData?.length === 0 && <NewMessage />}

              {mergedData?.map((each: any, eachIndex: number) => {
                return (
                  <div key={each.id}>
                    <Stepper
                      subSearchArray={each.subSerach || []}
                      activeStep={subSearchActiveSteps[eachIndex]}
                      handleStepChange={(step: number) => {
                        handleSubSearchStepChange(eachIndex, step)
                      }}
                    />
                  </div>
                )
              })}
              {/* <MessageProvider>
              <Messages />
            </MessageProvider> */}
              <p>
                The provided information outlines the required experience, skill sets, and
                responsibilities for a position related to designing and delivering UI solutions for
                network operational processes. Below is a breakdown of the qualifications and skills
                needed for this role.:
              </p>
            </Stack>

            <Stack
              sx={{
                flexShrink: 0,
                backgroundColor: '#F8F8F8',
                zIndex: 1100,
                paddingTop: 1,
                paddingBottom: 1,
              }}
            >
              <SendMessage
                setInputMessage={setInputMessage}
                setAnswer={setAnswer}
                aiStorage={aiStorage}
                setAiStorage={setAiStorage}
              />
            </Stack>
          </Stack>
        </Stack>
      </Main>{' '}
    </div>
  )
}

export default MainContent
